import type { ModalProps } from '@smiledragon-corp/sds-system';
import { Modal as SDModal } from '@smiledragon-corp/sds-system';
import { useEffect, useState } from 'react';

export const Modal = (props: ModalProps) => {
  const [containerRef, setContainerRef] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setContainerRef(document.getElementById('wrapper'));
  }, []);

  return <SDModal {...props} container={containerRef} />;
};
